import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Messages } from 'primereact/messages';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { Paginator } from 'primereact/paginator';

export class EmpresaTrabajadorAfil extends Component {
    constructor() {
        super();
        this.state = {
            empresatrabajadorafil: {},
            paginacion: { registrosPorPagina: 20 },
            idsenube: 0,
        }
        this.obtenerPagina();
    }

    cambiaPagina(event) {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first, paginacion });
        this.obtenerPagina();

    }

    obtenerPagina() {
        //let { paginacion } = this.state;
       
    }

    render() {
        let { paginacion } = this.state;
        return <div>
            <Growl ref={(el) => this.growl = el} />
            <Messages ref={(el) => this.messages = el}></Messages>
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid">
                            <div className="p-col-8"><h2>Administración consulta trabajador IMSS</h2></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-grid  p-fluid">
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <DataTable value={paginacion.datos} selectionMode="single" scrollable={true} header="Mis Emisores">
                          
                            <Column field="1" header="R.F.C." style={{ width: '100px' }} />
                            <Column field="2" header="Razón Social" style={{ width: '200px' }} />
                            <Column field="3" header="Regimen Fiscal" style={{ width: '100px' }} />
                            <Column field="4" header="Domicilio" style={{ width: '200px' }} />
                        </DataTable>
                      
                    </div>
                </div>
            </div>
        </div>
    }
}